/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { AlertSeverity } from '../utils/enum/Alerts';

export interface AlertHandlerState {
  message: string;
  severity: AlertSeverity;
  open: boolean;
}

const initialState: AlertHandlerState = {
  message: '',
  severity: AlertSeverity.ERROR,
  open: false,
};

const alertHandlerSlice = createSlice({
  name: 'errorHandler',
  initialState,
  reducers: {
    setAlertData(state, data) {
      state.message = data.payload.message;
      state.severity = data.payload.severity;
      state.open = data.payload.open;
    },
    resetAlertData(state) {
      state.open = false;
      state.severity = AlertSeverity.ERROR;
      state.message = '';
    }
  }
});

export const { setAlertData, resetAlertData } = alertHandlerSlice.actions;
export default alertHandlerSlice.reducer;
